<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    role="none"
  >
    <path d="M16 19L16 5" stroke="#042B5F" stroke-width="2.02222" stroke-linecap="round" />
    <path
      d="M10.5564 15.1094L7.55531 12.1083C7.49456 12.0475 7.49456 11.949 7.55531 11.8883L10.5564 8.88715"
      stroke="#042B5F"
      stroke-width="2.02222"
      stroke-linecap="round"
    />
    <path d="M9 12L15.2222 12" stroke="#042B5F" stroke-width="2.02222" stroke-linecap="round" />
  </svg>
</template>
